import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import XLSX from 'xlsx'
// import * as three from './views/three.module'
// import {OrbitControls} from './views/OrbitControls'
Vue.config.productionTip = false;
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// console.log("threethreethree---",three)
// console.log("kkkkkkkkkkkkkkkkkkOrbitControls---",OrbitControls)
// import 'lib-flexible'
import './utils/rem'

//引入高德地图
import AMap from 'vue-amap'
Vue.use(AMap)
// eruda.init();
// // 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  // key: 'a2b5f9e0fa156ca8faf399bba16c2d9e',
  key: 'de45c1a0e7ea44bea49388cea9cca2f7',
  // 插件集合 （插件按需引入）
  plugin: [
    'AMap.Geolocation',
    'AMap.CitySearch',
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geocoder',
    'AMap.MarkerClusterer',
    'AMap.DistrictSearch',
    'AMap.ControlBar',
    'AMap.RangingTool'
    // 'AMap.DistrictSearch'
  ],
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'AMap.DistrictSearch',
   'AMap.RangingTool'],

  v: '1.4.4',
  uiVersion: '1.0'
})


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
